export default __webpack_public_path__ + "static/media/dsc_logo.fdf99391.png";